import { NavLink } from 'react-router-dom';
import { NAV_ITEMS, ROUTES } from '@/app/routes';
import { NAV_ICONS } from '@/components/icons';
import { cn } from '@/lib/cn';
import { NavAttention } from './ActionBanner';
import { useNotifications } from './notification-context';

const BOTTOM_ITEMS = NAV_ITEMS.filter((item) => item.onBottomBar);

/** Mobile navigation. Replaces the sidebar below the `lg` breakpoint. */
export function BottomNav() {
  const { inbox } = useNotifications();

  return (
    <nav
      aria-label="Main"
      className="fixed inset-x-0 bottom-0 z-50 flex border-t border-border bg-canvas/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md lg:hidden"
    >
      {BOTTOM_ITEMS.map((item) => {
        const Icon = NAV_ICONS[item.icon];

        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cn(
                // min-w-0 lets five labels share a 320px screen without the bar
                // growing wider than the viewport.
                'flex min-w-0 flex-1 flex-col items-center gap-0.5 px-1 py-2 text-[10px] font-bold transition',
                isActive ? 'text-primary' : 'text-content-muted',
              )
            }
          >
            <span className="relative">
              <Icon className="size-5 shrink-0" />
              <NavAttention
                on={
                  (item.to === ROUTES.team && inbox?.nav.team) ||
                  (item.to === ROUTES.contests && inbox?.nav.contests) ||
                  false
                }
              />
            </span>
            <span className="max-w-full truncate">{item.shortLabel ?? item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
